<div class="device-container">
  <div class="d-flex w-100 pt-3 pb-3 pl-3 pr-2">
    <div class="d-flex flex-column align-items-center">
      <adp-image class="ml-15" imageClass="mb-3" imageKey="Global_Dashboard_PhonesPendingTest_Image"></adp-image>
    </div>
    <div class="d-flex flex-column w-75 pl-3">
      <div class="row">
        <div class="col-9">
          <p class="u-heading-4 mb-1 font-weight-bold color-red">
            <adp-label labelKey="Dashboard_PendingPhones_Heading"></adp-label>
          </p>
        </div>
        <div class="col-3">
          <p class="u-heading-4 mb-1 font-weight-bold color-red">{{totalPendingTest}}</p>
        </div>
      </div>
      <div>
        <ol>
          <li class="u-body-2 mb-1" *ngFor="let description of descriptionList">{{description}}</li>
        </ol>
      </div>
    </div>
    <div class="d-flex justify-content-end w-25">
      <div class="d-flex">
        <mat-divider [vertical]="true"></mat-divider>
        <div class="redirect-button d-flex align-items-center">
          <a routerLink="" sf-aria-label="Global_PendingTest_Aria_Label">
            <mat-icon [svgIcon]="'chevron-right-blue'"></mat-icon>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
